import ContatoStatusService from "../../services/ContatoStatusService";
import FormSelectSearchModal from "../forms/base/FormSelectSearchModal";
import FormContatoStatus from "../../pages/ContatoStatus/FormContatoStatus";
import Permissao from "../../controllers/Permissao";

export default class SelectContatoStatus extends FormSelectSearchModal {

    constructor(props) {
        super(props);
        this.getOptions = this.getOptions.bind(this);

        this.state.showBtns = this.props.showBtns === undefined ? true : this.props.showBtns;
        this.state.showBtnSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
        this.state.showBtnNewForm = this.state.showBtns && ((this.props.showBtnNewForm === undefined ? true : false) && Permissao.getInstance().getPermissao(73));
        this.state.showBtnNewSearch = this.state.showBtns && (this.props.showBtnSearch === undefined ? true : false);
    }

    getConfigFormNew() {
        return {
            title: 'Cadastro de Contato Status',
            sizeModal: 'modal-xl',
            config: {
                isModal: true
            },
            form: FormContatoStatus,
            onSave: (response) => {
                this.getOptions(() => {
                    if (response.data?.idContatoStatus) {
                        this.handleOpenSearch(null, response.data?.idContatoStatus);
                    } else {
                        this.handleOpenSearch();
                    }
                });
            },
            onClose: () => {
                //this.handleOpenSearch();
            }
        };
    };

    componentDidMount() {
        super.componentDidMount();
        this.getOptions(() => {
            if (this.dispachChangeDidMount && this.props.value) {
                this.handleChange({ target: { value: this.props.value, name: this.props.name } });
            }
        });
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getOptions(callBack) {
        var ativo = this.props.ativo === undefined ? null : this.props.ativo;
        
        ContatoStatusService.getForCombo(ativo, (response) => {
            this.setState({ options: response }, () => {
                if (callBack) {
                    callBack();
                }
            });
        });
    }

    render() {
        return super.render();
    }
}